import React from 'react';
import Info from '@mui/icons-material/Info';
import PropTypes from 'prop-types';

import { registerField } from 'core/forms';

import { Typo } from 'uikit/content';

import FormFieldSelect from 'uikit/forms/components/formFieldSelect';

import styles from '../styles/formFieldSelectWithDescription.module.scss';

const FormFieldSelectWithDescription = ({ fieldId, schema, updateField, value }) => (
  <>
    <FormFieldSelect fieldId={fieldId} schema={schema} updateField={updateField} value={value} />
    <div className={styles.element}>
      {value && (
        <>
          <Info className={styles.icon} sx={{ height: 18, width: 18 }} />
          <Typo color="secondary" className={styles.description} element="span" variant="b01">
            {schema.options.find((option) => option.value === value).description}
          </Typo>
        </>
      )}
    </div>
  </>
);

FormFieldSelectWithDescription.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    options: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
  }).isRequired,
  updateField: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

registerField('SelectWithDescription', React.memo(FormFieldSelectWithDescription));

export default FormFieldSelectWithDescription;
